
<div *ngIf="{
container: (containerRectData$ | async),
list: (list$ | async)
} as streams$">
  <div #container>
    <int-input
      [placeholder]="placeholder"
    >
      <ng-container ngProjectAs="left-position">
        <div class="list">
          <int-select
            defaultHeight="42px"
            [dropdownWidth]="streams$.container?.width || this.defaultDropdownWidth"
            [defaultHeightPriority]="true"
            [list]="streams$.list || []"
          ></int-select>
          <div class="flag-wrapper">
          </div>
        </div>
      </ng-container>
    </int-input>
  </div>
</div>

